var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"test-page"}},[_c('AttributeGroupContainer',{attrs:{"group_ids":_vm.group_ids,"page_index":_vm.answer_page_index},on:{"selected":_vm.answer_selected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }